export default [
    {
        path: '/vacations',
        name: 'indexVacations',
        meta: { title: 'indexVacations' },
        component: () => import('@/pages/vacations/index.vue'),
    },
    {
        path: "/vacations/create",
        name: "createVacations",
        meta: { title: 'createVacations' },
        component: () => import('@/pages/vacations/create.vue'),
    },
    {
        path: "/vacations/:id/edit",
        name: "editVacations",
        meta: { title: 'editVacations' },
        component: () => import('@/pages/vacations/edit.vue'),
    },
]